module.exports = __webpack_public_path__ + "img/arrow_down.fb78dc94.svg";